import { render, staticRenderFns } from "./ExternalDamagesList.vue?vue&type=template&id=27cb3f11&scoped=true"
import script from "./ExternalDamagesList.vue?vue&type=script&lang=ts"
export * from "./ExternalDamagesList.vue?vue&type=script&lang=ts"
import style0 from "./ExternalDamagesList.vue?vue&type=style&index=0&id=27cb3f11&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cb3f11",
  null
  
)

export default component.exports